import { useField, type FieldComponentProps } from "@w3rone/json-schema-form"
import { isValid } from "date-fns/isValid"
import { createContext, Fragment, ReactNode, useContext } from "react"
import { DatePicker } from "app/components/DatePicker"
import { FormErrors } from "./FormErrors"
import { format } from "date-fns"

export const DateField = ({ name }: FieldComponentProps) => {
  const {
    value: valueProps,
    onChange,
    label,
    schema,
    id,
    description,
    errors,
  } = useField(name)

  const value = valueProps ? new Date(String(valueProps)) : null

  const propProviderContext = useContext(DateFieldPropContext)

  return (
    <Fragment>
      <DatePicker
        value={value}
        onChange={(date) =>
          onChange?.(date && isValid(date) ? date.toISOString() : "")
        }
        label={label}
        disabled={schema.readOnly}
        minDate={propProviderContext?.minDate}
        maxDate={propProviderContext?.maxDate}
        slotProps={{
          textField: {
            id,
            helperText: description,
            error: errors.length > 0,
          },
        }}
      />
      {errors ? <FormErrors errors={errors} /> : null}
      <input
        type="hidden"
        name={name}
        value={value ? format(value, "yyyy-MM-dd") : ""}
      />
    </Fragment>
  )
}

const DateFieldPropContext = createContext<
  { minDate?: Date; maxDate?: Date } | undefined
>(undefined)

export const DateFieldPropProvider = ({
  minDate,
  maxDate,
  children,
}: DateFieldPropProviderProps) => {
  return (
    <DateFieldPropContext.Provider value={{ minDate, maxDate }}>
      {children}
    </DateFieldPropContext.Provider>
  )
}

interface DateFieldPropProviderProps {
  minDate?: Date
  maxDate?: Date
  children: ReactNode
}
